import moment from "moment";

class Et0Repository {
  constructor(api) {
    this.api = api;
  }
  async show() {
    let raw = `SELECT * FROM CROP.ET0;`;
    const et0 = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return et0[0];
  }

  async showEtoByStationAndInterval({ FK_STATION, START, END }) {
    let raw = `SELECT FK_STATION, TIME, VALUE FROM CROP.ET0 as et0
    WHERE et0.FK_STATION = ${FK_STATION}
    AND et0.TIME >= '${START}'
    AND et0.TIME <= '${END}'
    ORDER BY et0.TIME ASC;`;

    const et0 = await this.api.sql({
      data: {
        sql: raw
      }
    });


    return et0[0];
  }

  async getStationName(EMR) {
    let raw = `
      SELECT
        NAME
      FROM
        NEWSIR.CAD_SENSOR SENSOR
      WHERE
        SENSOR.ID = ${EMR}
    `;
    const data = await this.api.sql({
      data: {
        sql: raw
      }
    });

    let result =data.length && data[0].length? data[0][0]:null;

    return result;
  }

  async getSensorOptions(EMR) {

    const rawNameStation = `
      SELECT NAME
      FROM NEWSIR.CAD_SENSOR CS
      WHERE CS.ID = ${EMR};
    `;
    
    const stationNameResponse = await this.api.sql({ 
      data: {
        sql: rawNameStation
      }
    });
    
    const stationName = stationNameResponse
    && stationNameResponse[0]
    && stationNameResponse[0][0]  
    && stationNameResponse[0][0]["NAME"];

    if(!rawNameStation) {
      return undefined;
    }
    
    const raw = `
      SELECT 
        \`TYPE\`,
        UNIT,
         '${stationName}' NAME
      FROM LOG_SENSOR.\`${stationName}\` 
      GROUP BY \`TYPE\`;
    `;

    const options = await this.api.sql({
      data: {
        sql: raw
      }
    });

    const data = options[0]
    let result = null;
    //DTO
    if (data) {
      const UNITS = []
      const TYPES = []
      const STATION_NAME = [...new Set(data.map((el)=>el.NAME))]

      data.map((option) => {
        TYPES.push(option.TYPE)
        UNITS.push(option.UNIT)
      })

      result = {
        STATION_NAME,
        UNITS,
        TYPES
      }
    }

    return result;
  }
  //Só faz sentido calcular Predição quanto o index for menor do que 3
  //Caso contrário irá pegar do array de ET0
  async getET0Prediction(lastDate) {
    const firstDay = moment(lastDate)
      .subtract(3, "days")
      .hours(0)
      .minutes(0)
      .format("YYYY-MM-DD");

    const lastDay = moment(lastDate)
      .subtract(1, "days")
      .hours(23)
      .minutes(59)
      .format("YYYY-MM-DD");

    const raw = `
      SELECT AVG(VALUE) as AVG FROM CROP.ET0
      WHERE TIME BETWEEN '${firstDay}' AND '${lastDay}'
      ORDER BY TIME ASC;
    `
    const ET0 = await this.api.sql({
      data: {
        sql: raw
      }
    })


    if (ET0[0] && Object.keys(ET0[0][0]).length) {
      return ET0[0][0].AVG || 0
    }
    return 0;
  }

  async save(data) {
    let {
      FK_STATION, //ID da estação
      TIME, //  YYYY/MM/DD HH:mm
      VALUE //ET0
    } = data;

    let raw = `INSERT INTO CROP.ET0(FK_STATION,TIME,VALUE)VALUES(${FK_STATION},'${TIME}','${VALUE}');`;


    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(
        `[CRON] - Sucesso ao salvar dados da ET0 diária da estação ${FK_STATION}`
      );
    }

    return resp;
  }

  async del(FK_STATION) {


    let raw = `DELETE FROM CROP.ET0 WHERE FK_STATION = ${FK_STATION};`;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(`[CRON] - Sucesso ao deletar et0 da estação ${FK_STATION}.`);
    }

    return resp;
  }

  async deleteByInterval(FK_STATION, START, END) {


    let raw = `DELETE FROM CROP.ET0 WHERE FK_STATION = ${FK_STATION} AND TIME BETWEEN '${START}' AND '${END}';`;
    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (resp.length) {
      console.log(`[CRON] - Sucesso ao deletar et0 da estação ${FK_STATION} por intervalo.`);
    }

    return resp;
  }

  async savePrevData(values) {
    // let raw=`INSERT INTO CROP.ET0 (FK_STATION,TIME,VALUE) VALUES${values};`
    let raw = "INSERT INTO CROP.ET0 (FK_STATION,TIME,VALUE) VALUES" + values + ";";



    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });



    if (resp[0].length) {
      console.log(
        `[CRON] - Sucesso ao salvar dados de ET0 em dias anteriores.`
      );
    }

    return resp[0];
  }

  async showET0ByTime(TIME) {
    let raw = `
    SELECT * FROM CROP.ET0
    WHERE TIME = '${TIME}'
    ORDER BY TIME ASC;
    `;


    const et0 = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if (et0 && et0[0].length) {
      return et0[0][0];
    }
    return

  }
  async getEt0ByInterval(START, END) {
    let raw = `
      SELECT ID,TIME FROM CROP.ET0
      WHERE TIME BETWEEN '${START}' AND '${END}'
      ORDER BY TIME ASC;
    `;


    const et0 = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return et0[0];
  }
  async getEt0SinceFirstLog(START) {
    let raw = `
      SELECT * FROM (SELECT
        TIME,
        VALUE
      FROM
        CROP.ET0 as et0
        ORDER BY et0.TIME ASC
        ) AS ET0s
      WHERE ET0s.TIME >= '${START}';
    `;

    const et0 = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return et0
  }
}

export {
  Et0Repository
};
